import { TextBadge } from '#/components/Badge/TextBadge';
import { useI18n } from '#/i18n/hooks/useI18n';
import { SearchFacetAccordionItem } from '#/modules/search/components/Facet/AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from '#/modules/search/components/Facet/Dropdown/SearchFacetDropdown';
import { SearchFacetRadioButtonOptions } from '#/modules/search/components/Facet/Options/SearchFacetRadioButtonOptions';
import { SEARCH_COMMON_REFINEMENT_LABELS } from '#/modules/search/constants/refinements/searchCommonRefinementTypes';
import {
  useSearchLocation,
  useSearchRadius,
} from '#/modules/search/contexts/SearchContext';
import { isPointGeotype } from '#/modules/search/helpers/isPointGeotype';
import { useSearchRadiusOptions } from '#/modules/search/hooks/facets/useSearchRadiusOptions';
import { useSearchSingleChoiceSelectedValue } from '#/modules/search/hooks/facets/useSearchSingleChoiceSelectedValue';
import type { SearchRefinementVariant } from '#/modules/search/types/SearchRefinementVariant';

type Props = {
  variant: SearchRefinementVariant;
};

export function RadiusFacet({ variant }: Props) {
  const { i18n } = useI18n();
  const searchLocation = useSearchLocation();

  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  const options = useSearchRadiusOptions();
  const searchRadius = useSearchRadius();
  const searchRadiusFromURL = useSearchSingleChoiceSelectedValue('radius');
  const selectedFacetValue = searchRadius || searchRadiusFromURL;
  const selectedCount = selectedFacetValue ? 1 : 0;

  if (!searchLocation || !isPointGeotype(searchLocation.geoType)) return null;

  return (
    <FacetVariant
      icon="bulls-eye"
      facetType="radius"
      label={
        <>
          {SEARCH_COMMON_REFINEMENT_LABELS(i18n).radius}{' '}
          <TextBadge content={selectedCount} />
        </>
      }
    >
      <SearchFacetRadioButtonOptions
        facetType="radius"
        initialValue={searchRadius || searchRadiusFromURL}
        options={options}
        variant={variant === 'accordion' ? 'accordion' : 'dropdown'}
      />
    </FacetVariant>
  );
}
